import apiService from './api';
import { ApiResponse } from '../types';

/**
 * O catalogo de categorias de despesa da empresa.
 *
 * Era lista fixa no codigo, igual para todo mundo. Cada frota gasta com coisas
 * diferentes — borracharia e balanca num caminhao, higienizacao numa locadora —
 * e quem nao achava a sua lancava tudo em "outros", transformando o relatorio
 * de custo numa coluna gigante sem significado.
 */
export interface CategoriaDeDespesa {
  id: number;
  nome: string;
  /** A identidade: e o que fica gravado em cada despesa, e nunca muda. */
  slug: string;
}

export const categoriasDespesaService = {
  listar: async (): Promise<ApiResponse<CategoriaDeDespesa[]>> => {
    return apiService.get<ApiResponse<CategoriaDeDespesa[]>>('/v1/categorias-despesa');
  },

  criar: async (nome: string): Promise<ApiResponse<CategoriaDeDespesa>> => {
    return apiService.post<ApiResponse<CategoriaDeDespesa>>('/v1/categorias-despesa', { nome });
  },

  /**
   * Renomeia. O slug nao acompanha, de proposito: quem renomeia esta
   * corrigindo o nome de uma coisa que sempre foi a mesma, e trocar a
   * identidade partiria o relatorio em duas linhas.
   */
  renomear: async (id: number, nome: string): Promise<ApiResponse<CategoriaDeDespesa>> => {
    return apiService.put<ApiResponse<CategoriaDeDespesa>>(`/v1/categorias-despesa/${id}`, { nome });
  },

  /** Exclusao logica: as despesas ja lancadas continuam no historico. */
  excluir: async (id: number): Promise<ApiResponse<null>> => {
    return apiService.delete<ApiResponse<null>>(`/v1/categorias-despesa/${id}`);
  },
};
